import type { FC } from 'react';
import { useCallback } from 'react';
import clsx from 'clsx';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';

import { useControlStore } from 'store/controls';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import styles from './styles.module.scss';

const Leave: FC = () => {
    const { showLeaveModal } = useControlStore();
    const { triggerYM } = useYM();

    const handleClick = useCallback(() => {
        triggerYM({ goal: GoalType.CONFERENCE_PAGE_EXIT });
        showLeaveModal();
    }, []);

    return (
        <Button size='lg' kind='gray-red' borderRadius='xl' className={clsx(styles.leave)} onClick={handleClick}>
            Выйти
        </Button>
    );
};

export default Leave;
